import axios from "axios";
import {API_HOST} from "../core/variables";

class MemberRepository {
    async readLoginMember(channelId: string) {
        return axios.get(`${API_HOST}/v1/channels/${channelId}/members/me`);
    }

    async find_with_user_id(userId: string) {
        return axios.get(`${API_HOST}/v1/onboarding/members/${userId}`)
    }
}

const memberRepository = new MemberRepository();

export default memberRepository;
